import React from 'react';
import { X, Eye, EyeOff } from 'lucide-react';

export default function DashboardSettingsModal({ 
  onClose, 
  statsOrder, 
  summaryOrder, 
  widgetVisibility, 
  setWidgetVisibility, 
  widgetLabels,
  hasPermission
}) {
  const toggleVisibility = (id) => {
    setWidgetVisibility(prev => ({ ...prev, [id]: !prev[id] }));
  };

  const allWidgets = [...statsOrder, ...summaryOrder].filter(id => {
    if (!hasPermission) return true;
    return hasPermission(id);
  });

  return (
    <div style={{
      position: 'fixed', top: 0, right: 0, bottom: 0, width: '400px',
      backgroundColor: 'var(--bg-card)', boxShadow: '-5px 0 15px rgba(0,0,0,0.5)',
      zIndex: 1000, display: 'flex', flexDirection: 'column'
    }}>
      <div style={{ padding: '1.5rem', borderBottom: '1px solid var(--border-color)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h3 style={{ margin: 0, color: 'var(--primary)' }}>Dashboard Settings</h3>
        <button type="button" onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '1.5rem', color: 'var(--text-secondary)', cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
          <X size={20} />
        </button>
      </div>

      <div style={{ padding: '1.5rem', overflowY: 'auto', flex: 1, display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        <p style={{ color: 'var(--text-secondary)', fontSize: '0.875rem', marginBottom: '0.5rem' }}>
          Toggle the widgets you want to see on your dashboard. You can reorder them directly on the dashboard by dragging.
        </p>

        {allWidgets.map(id => (
          <div key={id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem', backgroundColor: 'var(--bg-input)', borderRadius: '8px' }}>
            <span style={{ fontWeight: 500, color: 'var(--text-primary)' }}>{widgetLabels[id] || id}</span>
            <button 
              onClick={() => toggleVisibility(id)}
              style={{ 
                background: 'none', 
                border: 'none', 
                color: widgetVisibility[id] !== false ? 'var(--primary)' : 'var(--text-secondary)',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem'
              }}
            >
              {widgetVisibility[id] !== false ? (
                <><Eye size={18} /> <span style={{fontSize:'0.8rem'}}>Visible</span></>
              ) : (
                <><EyeOff size={18} /> <span style={{fontSize:'0.8rem'}}>Hidden</span></>
              )}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
